import React, { useMemo } from 'react';
import { Icon, Text, Button, Flex, HStack, Link } from '@televet/kibble-ui';
import { useSurveySettingsContext } from 'pages/Survey/context/SurveySettingsContext';
import { SurveyType } from 'shared/types/graphql';

interface IThankYouStepProps {
  rating: number;
}

const ThankYouStep = ({ rating }: IThankYouStepProps): JSX.Element => {
  const { generalSettings, surveyType } = useSurveySettingsContext();

  const linkRatings = useMemo(() => {
    const ratings: number[] = [];
    if (surveyType === SurveyType.Csat) {
      if (generalSettings.showLinkToLeaveReviewNeutral) {
        ratings.push(3);
      }
      if (generalSettings.showLinkToLeaveReviewSatisfied) {
        ratings.push(4, 5);
      }
    } else {
      if (generalSettings.showLinkToLeaveReviewNeutral) {
        ratings.push(7, 8);
      }
      if (generalSettings.showLinkToLeaveReviewSatisfied) {
        ratings.push(9, 10);
      }
    }
    return ratings;
  }, [generalSettings.showLinkToLeaveReviewNeutral, generalSettings.showLinkToLeaveReviewSatisfied, surveyType]);

  const showLink = useMemo(
    () => generalSettings.linkToLeaveReview && linkRatings.includes(rating),
    [generalSettings.linkToLeaveReview, linkRatings, rating],
  );

  return (
    <Flex direction="column">
      <HStack className="preview__form-step" id="survey-preview-step-thankyou" mb={12}>
        <Icon name="checkmarkCircle" variant="success" />
        <Text>Thank you for your feedback!</Text>
      </HStack>
      {showLink && (
        <Button variant="primary" w="max-content" alignSelf="center" p={0}>
          <Link
            href={generalSettings.linkToLeaveReview || ''}
            variant="onContrast"
            textDecor="none"
            isExternal
            display="flex"
            alignItems="center"
            h="100%"
            w="100%"
            px={4}
            _hover={{
              textDecor: 'none',
            }}
          >
            {reviewButtonContent(generalSettings.linkToLeaveReview || '')}
          </Link>
        </Button>
      )}
    </Flex>
  );
};

export default ThankYouStep;

function reviewButtonContent(linkToLeaveReview: string): string {
  linkToLeaveReview = linkToLeaveReview.toLowerCase();
  const DEFAULT = 'Leave us a Review';
  const GOOGLE = 'Leave us a Google Review';
  const FACEBOOK = 'Leave us a Facebook Review';
  const YELP = 'Leave us a Yelp Review';
  if (
    linkToLeaveReview.includes('google') ||
    linkToLeaveReview.includes('g.page') ||
    linkToLeaveReview.includes('goo.gl') ||
    linkToLeaveReview.includes('g.co')
  ) {
    return GOOGLE;
  }
  if (linkToLeaveReview.includes('facebook')) {
    return FACEBOOK;
  }
  if (linkToLeaveReview.includes('yelp')) {
    return YELP;
  }
  return DEFAULT;
}
